module.exports = __webpack_public_path__ + "static/media/Slide1.303f6757.png";